export const defaultTranslations = {
  messageVerifyPhoneHelp: "You can verify your phone number easily by tapping on the button below.",
  messageTapWithdrawHelp: "Please complete previous steps before continuing to withdraw.",
  messageTapWithdrawHelp2: "All you need to do now is tap on the withdraw button below.",
  messageAddCardHelp: "Add a card below. We can only accept debit cards due to regulatory reasons.",
  messageVerifyPhoneHelp: "You can verify your phone number easily by tapping on the button below.",
  howToWithdrawStep1: "Verify phone",
  howToWithdrawStep2: "Add card",
  howToWithdrawStep3: "Tap withdraw",
  yourCurrentLimit: "Your current limit",
  yourPendingLimit: "Your pending limit",
  day: "day",
  days: "days",
  week: "week",
  month: "month",
  remove: "Remove",
  limit: "limit",
  save: "Save",
  type: "Type",
  requestedAmount: "The requested amount",
  amount: "Amount",
  password: "Password",
  enter: "Enter",
  required: "required",
  invalid: "invalid",
  tooHighError: "exceeds your balance",
  promoBalance: "Promo balance",
  characters: "characters",
  limitWillTakeEffect: "Limit will take effect",
  fastDeposit: "Fast Deposit",
  depositLimitUpdated: "Deposit limit updated",
  depositLimitError: "Error updating",
  depositLimitMessage: "Deposit limits control the amount you can deposit into your Low6 account. To assist you we can set an amount and also a time period for your desired limit.",
  addCard: "Add card",
  balance: "Balance",
  deposit: "Deposit",
  depositSuccess: "Deposit success",
  withdraw: "Withdraw",
  withdrawSuccess: "Withdraw success",
  unsuccessful: "Unsuccessful",
  addCardToWithdraw: "Add card to withdraw",
  addCardToDeposit: "Add card to deposit",
  enterAmount: "Enter amount",
  errorWithdraw: "Amount must be at least $15",
  errorDeposit: "Amount must be between $15 and $1200",
  yourPassword: "Your password",
  transactions: "Transactions",
  depositLimit: "Deposit limit",
  tappingHere: "Tapping here",
  howToWithdraw: "How To Withdraw",
  walletTextOpenOutsideIframe: "To add a card, please access your wallet through a web browser by",
  errorAddingCard: "Error adding card",
  errorAddingCardBalanceTooHigh: "Your cash balance needs to be £5 or less to enable payment card updates. You can do this by withdrawing funds.",
  errorAddingCardPhoneNumber: "Phone number not verified yet",
  minLengthError: "Minimum",
  maxLengthError: "Maximum",
  confirmIsFonix: "Deposit by Fonix"
};